/**
 * 포맷팅 유틸리티
 *
 * 날짜 포맷 (YYYY-MM-DD), 숫자 포맷 (천 단위 콤마) 등
 */

/**
 * 날짜를 YYYY-MM-DD 형식으로 포맷
 * @param date - Date 객체 또는 날짜 문자열
 * @returns YYYY-MM-DD 형식 문자열, 유효하지 않은 입력 시 빈 문자열
 */
export function formatDate(date: Date | string | null | undefined): string {
  if (date == null) {
    return '';
  }

  const d = typeof date === 'string' ? new Date(date) : date;

  if (isNaN(d.getTime())) {
    return '';
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * 숫자를 천 단위 콤마 포맷
 * @param value - 포맷할 숫자
 * @returns 콤마가 포함된 문자열, NaN이나 null/undefined 시 '0'
 */
export function formatNumber(value: number | null | undefined): string {
  if (value == null || isNaN(value)) {
    return '0';
  }

  const isNegative = value < 0;
  const absStr = Math.abs(value).toString();
  const parts: string[] = [];
  
  for (let i = absStr.length - 1, count = 0; i >= 0; i--, count++) {
    if (count > 0 && count % 3 === 0) {
      parts.unshift(',');
    }
    parts.unshift(absStr[i]);
  }

  return (isNegative ? '-' : '') + parts.join('');
}
